import "./App.css";
import Box from "@mui/material/Box";

import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import logogreen from "./assets/logos/logogreen.png";
import hivomusicLogo from "./assets/images/hivomusic-logo_white.png";
import hivomediaLogo from "./assets/images/hivomedia-logo_white.png";

import Timer2 from "./components/Timer2";

import { keyframes } from "@emotion/react";
import { Typography } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#fff",
    },
    secondary: {
      main: "#77AF3A",
    },
    background: {
      default: "#000",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundImage: `url(${logogreen})`,
          backgroundSize: "contain",
          width: 10,
          height: 10,
        },
      },
    },
  },
  shadows: [
    "none",
    "0px 0px 20px white",
    "0px 35px 60px red",
    "20px 55px 60px red",
    "10px 15px 60px red",
  ],
});

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline enableColorScheme />
        {/* <Box
          sx={{
            position: "absolute",
            left: 0,
            top: 0,
            backgroundColor: "#000",
            opacity: 1,
            height: 100,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            textAlign: "center",
          }}
        >
          <Box sx={{ margin: 0, padding: 0, spacing: 0}}>
            <Typography variant="body1" sx={{ color: "#00CC00" }}>
              <b>Vermietung</b> von Veranstaltungstechnik
              <br />
              sowie <b>Booking</b>-Anfragen unter
            </Typography>
            <Typography variant="body2" sx={{ color: "white", opacity: 0.8 }}>
              <a style={{ color: "white", textDecoration: "none" }} href="mailto: info@summerofsound.org">info@summerofsound.org</a>
            </Typography>
          </Box>
        </Box> */}
        <Box
          sx={{
            backgroundColor: "#000",
            opacity: 0.8,
            width: "100vw",
            height: "100vh",
            zIndex: 50,
            position: "absolute",
          }}
        ></Box>

        <Box
          sx={{
            zIndex: 100,
            position: "absolute",
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // backgroundColor: "green",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              width: "80vw",
              height: "100vw",
              maxHeight: "500px",
              // backgroundColor: "red",
              display: "flex",
              flexDirection: "column",
              // justifyContent: 'space-around'
            }}
          >
            <Box
              sx={{
                width: "100%",
                // backgroundColor: "blue",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Timer2 />
            </Box>
            <Box
              sx={{
                width: "100%",
                height: "60px",
                // backgroundColor: "pink",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography variant="body2" sx={{ color: "#00CC00" }}>
                coming soon July 2026 ...
              </Typography>
            </Box>
          </Box>
          {/* <Box
            sx={{ width: "300px", height: "100px", backgroundColor: "red" }}
          >
            TEST
          </Box> */}
          {/* <Box
            sx={{ width: "100%", height: "100%", backgroundColor: "blue" }}
          >
            TEST
          </Box> */}
          {/* <Timer2 /> */}
          {/* <Box
            sx={{ width: "300px", height: "100px", backgroundColor: "blue" }}
          >
            TEST
          </Box> */}
        </Box>
        <Box
          sx={{
            width: "100%",

            height: "40px",
            position: "absolute",
            bottom: 0,
            zIndex: 200,
            backgroundColor: "#000D",
            display: "flex",
            justifyContent: "space-around",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "500px",
              height: "100%",
              position: "absolute",
              bottom: 0,
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              gap: "10px",
              paddingX: "10px",
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "50%",
                cursor: "pointer",
                opacity: 0.5,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundImage: `url(${hivomusicLogo})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                "&:hover": { opacity: 0.9 },
              }}
              onClick={() => window.open("https://www.hivomusic.de")}
            ></Box>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                opacity: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  cursor: "pointer",
                  color: "#ffffff",
                  alignSelf: "end",
                  paddingBottom: "5px",
                  opacity: 0.5,
                  "&:hover": { opacity: 0.9 },
                  fontSize: "12px",
                }}
                onClick={() =>
                  window.open("https://www.summerofsound.org/impressum")
                }
              >
                Impressum
              </Typography>
            </Box>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                opacity: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  cursor: "pointer",
                  color: "#ffffff",
                  alignSelf: "end",
                  paddingBottom: "5px",
                  opacity: 0.5,
                  "&:hover": { opacity: 0.9 },
                  fontSize: "12px",
                }}
                onClick={() =>
                  window.open("https://www.summerofsound.org/datenschutz")
                }
              >
                Datenschutz
              </Typography>
            </Box>
            <Box
              sx={{
                width: "100%",
                height: "50%",
                cursor: "pointer",
                opacity: 0.5,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundImage: `url(${hivomediaLogo})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                "&:hover": { opacity: 0.9 },
              }}
              onClick={() => window.open("https://www.hivomedia.de")}
            ></Box>
          </Box>
        </Box>
      </ThemeProvider>
    </>
  );
}

export default App;
